const d = {
  1: {
    default: "#5EBABA",
    light: "#82C9C9",
    dark: "#45A1A1",
    border: "#5EBABA"
  },
  2: {
    default: "#477285",
    light: "#598EA6",
    dark: "#355564",
    border: "#477285"
  },
  3: {
    default: "#FB7F65",
    light: "#FCA897",
    dark: "#FA5633",
    border: "#FB7F65"
  },
  4: {
    default: "#B8AA94",
    light: "#CCC1B2",
    dark: "#A39075",
    border: "#B8AA94"
  },
  5: {
    default: "#F2BD0D",
    light: "#F5CA3D",
    dark: "#C2970A",
    border: "#F2BD0D"
  },
  6: {
    default: "#BD7B42",
    light: "#CA9168",
    dark: "#975E35",
    border: "#BD7B42"
  },
  7: {
    default: "#B2DFDB",
    light: "#D7EFEC",
    dark: "#8FD1CB",
    border: "#B2DFDB"
  },
  8: {
    default: "#F8BBD0",
    light: "#FDE8EF",
    dark: "#F38BAF",
    border: "#F8BBD0"
  },
  9: {
    default: "#977294",
    light: "#AD90AA",
    dark: "#7B5B78",
    border: "#977294"
  },
  10: {
    default: "#C5C5C5",
    light: "#DEDEDE",
    dark: "#ABABAB",
    border: "#C5C5C5"
  },
  11: {
    default: "#CF83DB",
    light: "#DFACE7",
    dark: "#C05DD0",
    border: "#CF83DB"
  },
  12: {
    default: "#7092A2",
    light: "#90AAB7",
    dark: "#587988",
    border: "#7092A2"
  },
  13: {
    default: "#BAC62E",
    light: "#CCD751",
    dark: "#949D25",
    border: "#BAC62E"
  },
  14: {
    default: "#8D6E63",
    light: "#A5887E",
    dark: "#6F564E",
    border: "#8D6E63"
  }
}, A = (r) => d[r];
export {
  d as CATEGORICAL_PALETTES,
  A as getCategorical
};
//# sourceMappingURL=index.es656.js.map
